export const CUSTOMER_DILIGENCE_REQUIREMENTS_URL =
  'https://www.federalregister.gov/documents/2016/05/11/2016-10567/' +
  'customer-due-diligence-requirements-for-financial-institutions#footnote-44-p29407';
